import S from 's-js';

import { VesselServiceOverride, VesselServiceOverrideParams } from 'portcall/vesselserviceoverride/model';
import { VesselServiceOverrideCache } from 'portcall/vesselserviceoverride/cache';

import { VesselPortCalls, VesselPortCallsParams } from 'portcall/vesselportcalls/model';
import { VesselPortCallsCache } from 'portcall/vesselportcalls/cache';

export interface VesselServiceProfileParams extends VesselServiceOverrideParams, VesselPortCallsParams {
    id : number;
    mode : VesselServiceProfileMode;
}

export enum VesselServiceProfileMode {
    Particulars,
    PortCalls
}

export function VesselServiceProfile(
    params : VesselServiceProfileParams,
    vesselServiceOverrideModel : (params : VesselServiceOverrideParams) => VesselServiceOverride,
    vesselPortCallsModel : (params : VesselPortCallsParams) => VesselPortCalls
) {
    const { id, mode: _mode } = params,
        mode = S.data(_mode),
        vesselServiceOverride = vesselServiceOverrideModel(params),
        vesselPortCalls = vesselPortCallsModel(params);

    return {
        Id: id,
        VesselServiceOverride : vesselServiceOverride,
        VesselPortCalls : vesselPortCalls,
        GoBack: () => window.history.back(),
        GoParticulars,
        GoPortCalls,
        Mode : mode
    };

    function GoParticulars(){
        mode(VesselServiceProfileMode.Particulars);
    }

    function GoPortCalls(){
        mode(VesselServiceProfileMode.PortCalls);
    }
}
export type VesselServiceProfile = ReturnType<typeof VesselServiceProfile>;


// WEBPACK FOOTER //
// ./apps/portcall/vesselserviceprofile/model.ts